let msConfig = {
  appId: 'dea1eb12-3123-4b3c-8f7a-4eae7ba7a0e2',
  redirectUri: 'https://dashboard.boltinsight.com/pages/login',
  postLogoutRedirectUri: 'https://dashboard.boltinsight.com/pages/login',
  scopes: ['user.read'],
  authority: 'https://login.microsoftonline.com/boltinsight.com',
};

if (process.env.REACT_APP_ENV === 'dev') {
  // DEV ENVIRONMENT

  msConfig.appId = '29a6f2f5-b629-45e2-b496-1fc7c94e6e0f';
  msConfig.redirectUri = 'https://dashboard-dev.boltinsight.com/pages/login';
  msConfig.postLogoutRedirectUri =
    'https://dashboard-dev.boltinsight.com/pages/login';
}

if (process.env.NODE_ENV === 'development') {
  if (process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'dev') {
    msConfig.appId = 'd1c05f3a-1b39-4dbe-962a-b4c758a81e5d';
    msConfig.redirectUri = 'http://localhost:3000/pages/login';
    msConfig.postLogoutRedirectUri = 'http://localhost:3000/pages/login';
  } else {
    msConfig.appId = '29a6f2f5-b629-45e2-b496-1fc7c94e6e0f';
    msConfig.redirectUri = 'https://dashboard-dev.boltinsight.com/pages/login';
    msConfig.postLogoutRedirectUri =
      'https://dashboard-dev.boltinsight.com/pages/login';
  }
}
//
export { msConfig };
